import {
  MakeAuthHeader, NetworkApi
} from "../../config/api";
import { toDateString, toDateTimeString } from "../../helpers/Utils";
import axios from "axios";

const state = {
  loading: false,
  date: new Date(),
  pipes: [],
  washouts: [],
  hydrants: [],
  valves: [],
  prvs: [],
  pmvs: [],
  meters: [],
  tappingPoints: [],
};

const getters = {
  loading(state) {
    return state.loading;
  },
  pipes(state) {
    return state.pipes;
  },
  washouts(state) {
    return state.washouts;
  },
  hydrants(state) {
    return state.hydrants;
  },
  valves(state) {
    return state.valves;
  },
  prvs(state) {
    return state.prvs;
  },
  pmvs(state) {
    return state.pmvs;
  },
  meters(state) {
    return state.meters;
  },
  tappingPoints(state) {
    return state.tappingPoints;
  },
  dateFormatted(state) {
    return toDateString(state.date);
  },
  dateNowFormatted() {
    return toDateTimeString(new Date());
  },
};

const mutations = {
  setLoading(state, payload) {
    state.loading = payload;
  },
  setPipes(state, payload) {
    state.pipes = payload;
  },
  setHydrants(state, payload) {
    state.hydrants = payload;
  },
  setWashouts(state, payload) {
    state.washouts = payload;
  },
  setValves(state, payload) {
    state.valves = payload;
  },
  setPrvs(state, payload) {
    state.prvs = payload;
  },
  setPmvs(state, payload) {
    state.pmvs = payload;
  },
  setMeters(state, payload) {
    state.meters = payload;
  },
  setTappingPoints(state, payload) {
    state.tappingPoints = payload;
  },
  clear(state) {
    state.pipes = [];
    state.hydrants = [];
    state.valves = [];
    state.washouts = [];
    state.meters = [];
    state.prvs = [];
    state.pmvs = [];
    state.tappingPoints = [];
  },
  setSelected(state, payload) {
    state.selected = payload;
  }
};

const actions = {
  getNetwork({ dispatch, rootGetters }) {
    return new Promise(resolve => {
      var group = rootGetters["group/activeGroupObj"];
      const data = {
        account: group.account,
        group: group.groupId.toString()
      };
      let options = {
        headers: MakeAuthHeader(rootGetters["login/networkApiToken"]),
        url: `${NetworkApi}NetworkGroup/meta`,
        method: "POST",
        data: data
      };
      axios(options)
      .then(res => {
        if(res.data) {
          var promises = [];
          promises.push(dispatch("getPipes", res.data.networkId));
          promises.push(dispatch("getHydrants", res.data.networkId));
          promises.push(dispatch("getValves", res.data.networkId));
          promises.push(dispatch("getWashouts", res.data.networkId));
          promises.push(dispatch("getPrvs", res.data.networkId));
          promises.push(dispatch("getPmvs", res.data.networkId));
          promises.push(dispatch("getMeters", res.data.networkId));
          promises.push(dispatch("getTappingPoints", res.data.networkId))
          Promise.all(promises)
          .then(() => {
            resolve();
          })
        }
        else {
          resolve();
        }
      })
      .catch(error => {
        console.warn(error);
        resolve(false);
      })
    })
  },
  getPipes({ commit, rootGetters }, network) {
    return new Promise(resolve => {
      const data = {
        account: rootGetters["login/accountId"],
        id: network,
        includePipes: true
      };
      let options = {
        headers: MakeAuthHeader(rootGetters["login/networkApiToken"]),
        url: `${NetworkApi}network/network`,
        method: "POST",
        data: data
      };
      axios(options)
      .then(res => {
        commit("setPipes", res.data.pipes);
        resolve(true);
      })
      .catch(error => {
        console.warn(error);
        resolve(false);
      })
    })
  },
  getHydrants({ commit, rootGetters }, network) {
    return new Promise(resolve => {
      const data = {
        account: rootGetters["login/accountId"],
        id: network,
        includeHydrants: true
      };
      let options = {
        headers: MakeAuthHeader(rootGetters["login/networkApiToken"]),
        url: `${NetworkApi}network/network`,
        method: "POST",
        data: data
      };
      axios(options)
      .then(res => {
        commit("setHydrants", res.data.hydrants);
        resolve(true);
      })
      .catch(error => {
        console.warn(error);
        resolve(false);
      })
    })
  },
  getValves({ commit, rootGetters }, network) {
    return new Promise(resolve => {
      const data = {
        account: rootGetters["login/accountId"],
        id: network,
        includeValves: true
      };
      let options = {
        headers: MakeAuthHeader(rootGetters["login/networkApiToken"]),
        url: `${NetworkApi}network/network`,
        method: "POST",
        data: data
      };
      axios(options)
      .then(res => {
        commit("setValves", res.data.valves);
        resolve(true);
      })
      .catch(error => {
        console.warn(error);
        resolve(false);
      })
    })
  },
  getWashouts({ commit, rootGetters }, network) {
    return new Promise(resolve => {
      const data = {
        account: rootGetters["login/accountId"],
        id: network,
        includeWashouts: true
      };
      let options = {
        headers: MakeAuthHeader(rootGetters["login/networkApiToken"]),
        url: `${NetworkApi}network/network`,
        method: "POST",
        data: data
      };
      axios(options)
      .then(res => {
        commit("setWashouts", res.data.washouts);
        resolve(true);
      })
      .catch(error => {
        console.warn(error);
        resolve(false);
      })
    })
  },
  getPrvs({ commit, rootGetters }, network) {
    return new Promise(resolve => {
      const data = {
        account: rootGetters["login/accountId"],
        id: network,
        includePrvs: true
      };
      let options = {
        headers: MakeAuthHeader(rootGetters["login/networkApiToken"]),
        url: `${NetworkApi}network/network`,
        method: "POST",
        data: data
      };
      axios(options)
      .then(res => {
        commit("setPrvs", res.data.prvs);
        resolve(true);
      })
      .catch(error => {
        console.warn(error);
        resolve(false);
      })
    })
  },
  getPmvs({ commit, rootGetters }, network) {
    return new Promise(resolve => {
      const data = {
        account: rootGetters["login/accountId"],
        id: network,
        includePmvs: true
      };
      let options = {
        headers: MakeAuthHeader(rootGetters["login/networkApiToken"]),
        url: `${NetworkApi}network/network`,
        method: "POST",
        data: data
      };
      axios(options)
      .then(res => {
        commit("setPmvs", res.data.pmvs);
        resolve(true);
      })
      .catch(error => {
        console.warn(error);
        resolve(false);
      })
    })
  },
  getMeters({ commit, rootGetters }, network) {
    return new Promise(resolve => {
      const data = {
        account: rootGetters["login/accountId"],
        id: network,
        includeDistrictMeters: true
      };
      let options = {
        headers: MakeAuthHeader(rootGetters["login/networkApiToken"]),
        url: `${NetworkApi}network/network`,
        method: "POST",
        data: data
      };
      axios(options)
      .then(res => {
        commit("setMeters", res.data.districtMeters);
        resolve(true);
      })
      .catch(error => {
        console.warn(error);
        resolve(false);
      })
    })
  },
  getTappingPoints({ commit, rootGetters }, network) {
    return new Promise(resolve => {
      const data = {
        account: rootGetters["login/accountId"],
        id: network,
        includeTappingPoints: true
      };
      let options = {
        headers: MakeAuthHeader(rootGetters["login/networkApiToken"]),
        url: `${NetworkApi}network/network`,
        method: "POST",
        data: data
      };
      axios(options)
      .then(res => {
        commit("setTappingPoints", res.data.tappingPoints);
        resolve(true);
      })
      .catch(error => {
        console.warn(error);
        resolve(false);
      })
    })
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
